import React from 'react';
import Header from '../header/header';
import Footer from '../footer/footer';

const QuiSuisJe = (props) => {
  return (
    <div>
          <Header />

    <div id="activites">

      <div className="container">
        <div>
          <div className="col-xs-12 col-md-6">
            {" "}
            <br></br><br></br>
<img className="img-responsive" src="../img/version1/delphia/5.jpg" alt="Fleuriste Chennevières-sur-Marne - création bouquet fleurs Delphia Paul fleuriste 94" />
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="section-title">
              <br></br><br></br>
             <section> <h2>Qui suis-je ?</h2>
              <br></br>
              <br></br> 
          <div className="activites-list">

<h3>Fleuriste et créatrice florale passionnée</h3>
              <br></br>

      <p>
        Je suis <strong>DELPHIA PAUL</strong>, artisan fleuriste, paysagiste et créatrice indépendante basée en Île-de-France. Je mets ma passion, mon expertise et mon savoir-faire au service de vos plus beaux projets floraux.
      </p>

      <p>
        Ma mission est de sublimer vos événements et vos espaces grâce à l’art floral et végétal, avec une approche humaine, sensible et engagée.
      </p>
              <br></br>

      <h4>Créations florales pour événements et mariages en Île-de-France</h4>

      <p>
        J’imagine et réalise des créations florales sur mesure pour vos mariages, événements privés, entreprises, hôtels ou espaces verts. Chaque création est pensée pour refléter votre univers et sublimer chaque instant.
      </p>
              <br></br>

      <h4>Compositions florales personnalisées</h4>

      <p>
        Je conçois des bouquets décoratifs, centres de table, arches fleuries et accessoires floraux entièrement personnalisés. Chaque composition est unique et adaptée à votre occasion.
      </p>
              <br></br>

      <h4>Paysagiste et aménagement d’espaces verts</h4>

      <p>
        En tant que paysagiste en Île-de-France, j’interviens pour l’aménagement et l’entretien de jardins, terrasses, espaces professionnels et copropriétés.
      </p>
              <br></br>

      <h4>Collaborations professionnelles</h4>

      <p>
        Je collabore avec des fleuristes, décorateurs, wedding planners et entreprises afin de proposer des prestations florales adaptées aux projets professionnels et aux événements.
      </p>
              <br></br>

      <h4>Ateliers floraux créatifs et participatifs</h4>

      <p>
        Je propose également des ateliers floraux pour enfants, seniors, associations et entreprises. Ces moments permettent de découvrir l’art floral dans une ambiance conviviale et créative.
      </p>
              <br></br>

   
</div>
    </section>

    
    

            </div>
          </div>
        </div>

      </div>
      </div>
      <Footer />

    </div>
  );
};
export default QuiSuisJe